module.exports = __webpack_public_path__ + "static/img/sidebar-logo-user.b0813d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/APRILYOS/sidebar-logo-user.png
// module id = n1hM
// module chunks = 0